import type { DocumentType } from "./types";

export const QUOTATION_INVOICE_DOCUMENT_TYPE_LABELS: Record<
  DocumentType,
  string
> = {
  quotation: "ໃບສະເໜີລາຄາ",
  invoice: "ໃບເກັບເງິນ",
  receipt: "ໃບຮັບເງິນ",
};

export function parseQuotationInvoiceDocumentType(
  raw: string | null | undefined,
): DocumentType | null {
  if (raw == null || typeof raw !== "string") return null;
  const v = raw.trim().toLowerCase();
  if (v === "quotation" || v === "invoice" || v === "receipt") return v;
  return null;
}

export function quotationInvoiceDocumentTypeDisplayName(
  code: string | null | undefined,
): string {
  const parsed = parseQuotationInvoiceDocumentType(code);
  if (parsed) return QUOTATION_INVOICE_DOCUMENT_TYPE_LABELS[parsed];
  return typeof code === "string" ? code : "";
}
